export default __webpack_public_path__ + "static/media/MICE-contact-img-mb@2x.b8fa400f.jpg";